import { render, staticRenderFns } from "./ot-server-error-handler-wrapper.vue?vue&type=template&id=30e6415d&scoped=true&"
import script from "./ot-server-error-handler-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-server-error-handler-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-server-error-handler-wrapper.vue?vue&type=style&index=0&id=30e6415d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e6415d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
